"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
class Activity extends model_core_1.Base {
    action = null;
    reaction = {};
    ref = null;
    type = '';
    user_id = '';
    object = null;
    info;
    constructor(data, olMap) {
        super('activity', 12);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, Activity);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
        if (this.ref) {
            if (opts?.getDoc) {
                this.object = (0, model_core_1.loadObject)(await opts.getDoc(this.ref), opts);
            }
            else if (this.ref?.get) {
                this.object = (0, model_core_1.loadObject)(await this.ref.get(), opts);
            }
        }
    }
    async setInfo(opts, player, viewer) {
        await this.loadAll(opts);
        if (this.object?._exists) {
            await this.object.loadAll(opts);
        }
        this.info = this.info || {};
        let cRef;
        let eRef;
        let eM;
        if (this.object instanceof index_1.Email) {
            eM = this.object;
            cRef = this.object.cRef;
            eRef = this.object.eRef;
        }
        else if (this.object instanceof index_1.CollegeRef) {
            cRef = this.object;
        }
        else if (this.object instanceof index_1.RcrtEventRef) {
            eRef = this.object;
            await eRef.loadAll(opts);
        }
        else if (this.object instanceof index_1.Comment) {
            eRef = this.object.eRef;
            cRef = this.object.cRef;
            eM = this.object.email;
        }
        if (cRef || eRef) {
            this.info.url = eRef && cRef ? `/account/colleges/${cRef?.id}/event/${eRef?.id}` : cRef ? `/account/colleges/${cRef?.id}` : eRef ? `/account/events/${eRef.id}` : '';
            if (eM?.id) {
                this.info.url = `${this.info.url}/email/${eM.id}`;
            }
            this.info.src = cRef ? `${cRef?.college?.image?.src}` : eRef ? `${eRef?.event?.image?.src}` : '';
            this.info.description = eRef ? `${eRef.event?.title}/${cRef?.college?.title}` : `${cRef?.college?.title}`;
        }
        if (this.object instanceof index_1.RcrtShare) {
            this.info.description = this.object.title;
            this.info.src = player?.image?.src;
            if (this.object._docRef.parent?.parent?.parent?.id === 'events') {
                this.info.url = `/account/events/${this.object._docRef.parent.parent.id}`;
            }
            else {
                this.info.url = `/account/share`;
                this.info.qP = { p: 1, tab: 'shares' };
            }
        }
        switch (this.action) {
            case index_1.ERcrtActions.EMAIL_FAILURE:
                // Hide this one if the user took care of it.
                if (player?.metadata?.email) {
                    this.active = false;
                }
                else {
                    this.info.label = 'Your Email Connection Broke!';
                    this.info.description = 'Click here to re-connect.';
                    this.info.url = `/account/emails/sync`;
                    this.info.src = `/assets/icons/128x128.png`;
                }
                break;
            case index_1.ERcrtActions.COLLAB:
                this.info.label = 'You Are a Collab!';
                this.info.description = 'Click here to view your collabs list';
                this.info.url = `/account/collabs`;
                break;
            case index_1.ERcrtActions.REACT:
                this.info.label = 'Reaction';
                if (this.reaction?.u?.name) {
                    this.info.label = `${this.reaction?.u.name} Reacted`;
                }
                if (this.reaction.r === 'u') {
                    this.info.emoji = '&#x1F44D;';
                }
                else if (this.reaction.r === 'd') {
                    this.info.emoji = '&#x1F44E;';
                }
                this.info.description = `to comment: "${this.object.message}"`;
                break;
            case index_1.ERcrtActions.COMMENT:
                let c = this.object;
                this.info.url += '/notes';
                if (c?.creator?.first_name) {
                    this.info.label = `${c.creator.first_name} Commented`;
                    this.info.description = c.message;
                    this.info.src = c.creator?.image?.src || this.info.src;
                }
                break;
            case index_1.ERcrtActions.SHARE:
                this.info.label = eRef ? `Event Share Created` : 'Player Share Created';
                this.info.url = eRef ? `/account/events/${eRef.id}` : `/account/share`;
                break;
            case index_1.ERcrtActions.DRAFT:
                this.info.description = eRef ? `${eRef.event?.title}/${cRef?.college?.title}` : `${cRef?.college?.title}`;
                this.info.label = eRef ? 'Event Email Drafted' : 'College Email Drafted';
                break;
            case index_1.ERcrtActions.REPLIES:
            case index_1.ERcrtActions.EMAIL:
                this.info.description = eRef ? `${eRef.event?.title}/${cRef?.college?.title}` : `${cRef?.college?.title}`;
                if (this.object['from']) {
                    this.info.label = (this.object['msgId'] === this.object['threadId']) ? 'College Email Received!' : 'College Coach Replied!';
                }
                else if (this.object['results_sent']) {
                    this.info.label = eRef ? 'Event Email Sent' : 'College Email Sent';
                }
                else {
                    this.info.label = eRef ? 'Event Email Drafted' : 'College Email Drafted';
                }
                break;
            case index_1.ERcrtActions.PROFILE_VIEW:
                this.info.label = `Profile Viewed`;
                break;
            case index_1.ERcrtActions.VIEW:
            case index_1.ERcrtActions.PLAY:
                if (this.object instanceof index_1.Email) {
                    this.info.label = eRef ? 'Event Email Viewed' : `College Email Viewed`;
                }
                else if (this.object instanceof index_1.RcrtShare) {
                    this.info.label = eRef ? `Event Share` : `Player Share`;
                    this.info.label += (this.action === index_1.ERcrtActions.PLAY) ? ` Video Played` : ` Viewed`;
                }
                break;
            case index_1.ERcrtActions.VCARD:
                this.info.label = `Card Downloaded`;
                break;
        }
        if (viewer?.id && viewer?.id !== player.id) {
            this.info.description = `${player.name} ${this.info.description}`;
        }
    }
    toJSON() {
        let r = super.toJSON();
        if (!this.ref) {
            throw `Cannot save Activity without a ref!`;
        }
        ['active', 'object', 'last_date'].forEach(p => {
            delete r[p];
        });
        return r;
    }
}
exports.Activity = Activity;
index_1.olm.activity = (ref, map) => {
    return new Activity(ref, map);
};
